export default __webpack_public_path__ + "static/media/office-desk_large.8de73ced.jpg";